<template>
  <b-form @keydown="form.errors.clear()" @submit.prevent="onSubmit">
    <div v-for="(contact, index) in form.contacts" :key="index" class="row">
      <div class="col">
        <b-card :key="`${renderKey}-${index}`" class="mb-3">
          <template #header>Emergency Contact #{{ index + 1 }}</template>
          <div class="row">
            <div class="col">
              <form-text
                v-model="contact.first_name"
                :name="`first_name-${index}`"
                :single-row="false"
              >
                First Name
              </form-text>
            </div>

            <div class="col">
              <form-text
                v-model="contact.last_name"
                :name="`last_name-${index}`"
                :single-row="false"
              >
                Last Name
              </form-text>
            </div>
            <div class="col">
              <form-email v-model="contact.email" :name="`email-${index}`" :single-row="false">
                Email
              </form-email>
            </div>
            <div class="col">
              <form-text v-model="contact.mobile" :name="`mobile-${index}`" :single-row="false">
                Mobile
              </form-text>
            </div>
            <div class="col">
              <form-text
                v-model="contact.relationship"
                :name="`relationship-${index}`"
                :single-row="false"
              >
                Relationship
              </form-text>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <form-address
                v-model="contact.addresses[0].id"
                :address="contact.addresses[0]"
                :addressable-id="currentUser.id"
                :name="`address-${index}`"
                :replaceable="true"
                :single-row="false"
                addressable-type="emergency-contact"
                @change="contact.addresses[0].id = null"
                @updateAddress="contact.addresses[0] = $event"
              >
                Address
              </form-address>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div class="text-right">
      <button :disabled="form.notReady()" class="btn btn-primary">
        <font-awesome-icon v-if="form.busy" :icon="['fal', 'spinner']" spin />
        <font-awesome-icon v-else :icon="['fal', 'check']" />
        Save
      </button>
    </div>
  </b-form>
</template>

<script type="text/babel">
import EventBus from "../../../imports/event-bus";

export default {
  props: {
    currentUser: {
      required: true,
    },
  },

  data() {
    return {
      renderKey: "contact",

      form: new window.AppForm({
        contacts: [
          {
            user_id: null,
            first_name: null,
            last_name: null,
            relationship: null,
            email: null,
            mobile: null,
            addresses: [
              {
                id: null,
                street: null,
                city: null,
                state: null,
                postcode: null,
              },
            ],
          },
          {
            user_id: null,
            first_name: null,
            last_name: null,
            relationship: null,
            email: null,
            mobile: null,
            addresses: [
              {
                id: null,
                street: null,
                city: null,
                state: null,
                postcode: null,
              },
            ],
          },
        ],
      }),
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      this.$http.get(`/users/${this.currentUser.id}/emergency-contacts`).then((response) => {
        response.body.forEach((contact, index) => {
          this.form.contacts[index] = contact;

          // Init Addresses
          if (contact.addresses.length === 0) {
            this.form.contacts[index].addresses = [
              {
                id: null,
                street: null,
                city: null,
                state: null,
                postcode: null,
              },
            ];
          }
        });

        // To force form fields update themselves
        this.renderKey = "contact-ready";

        this.form.finishProcessing();
      });
    },

    onSubmit() {
      this.form.put(`/users/${this.currentUser.id}/emergency-contacts`).then(() => {
        EventBus.$emit("user-updated");

        this.init();
        window.toastr.success("Emergency Contacts updated!", "Success");
      });
    },
  },
};
</script>
